import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import FlagIcon from '@atlaskit/icon/core/flag';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.flag-field.icon-label',
		defaultMessage: 'Flag field icon',
		description: 'Accessible label for the flag field icon in the work item action card',
	},
});

export function FlagFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<FlagIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
